import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#000";
function FLT({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path fillRule="evenodd" d="M12.641 6.692V4.01H11.42v2.673c-2.7.29-4.8 2.558-4.8 5.318s2.1 5.029 4.8 5.314v2.673h1.222v-2.68c2.67-.316 4.74-2.573 4.74-5.31 0-2.738-2.07-4.996-4.74-5.31zm-1.222 9.401c-2.022-.281-3.578-2.006-3.578-4.091s1.556-3.81 3.578-4.091zm1.222-.008V7.921a4.14 4.14 0 013.514 4.084 4.14 4.14 0 01-3.514 4.084z" /></Svg>;
}
FLT.DefaultColor = DefaultColor;
export default FLT;